import React from "react";
import { Countries } from "../SelectCountry/countries";
import "./NumberSection.css";

export const NumberSection = (props) => {
  const handleChangeNumber = (e) => {
    props.userSetNumber(e.target.value);
  };
  const handleChangeCountry = (e) => {
    props.setCountryCode(e.target.value);
  };
  const handleClick = () => {
    props.sendData(1);
  };
  return (
    <>
      <h1 className="heading_text mt-5">
        شكرا {props.userName} الآن نحتاج رقمك لنتمكن من التواصل معك
      </h1>
      <div className="input_container mt-5">
        <div className="input-group mb-3">
          <input
            type="text"
            name="number"
            id="number"
            className="input_field form-control"
            placeholder="رقم هاتفك مع مفتاح دولتك"
            value={props.userNumber}
            onChange={handleChangeNumber}
            autoFocus
            dir="rtl"
            // maxLength={10}
          />
          <span className="input-group-text" id="basic-addon1">
            <select
              className="form-select country_code_section"
              value={props.countyCode}
              id="inputGroupSelect01"
              onChange={handleChangeCountry}
            >
              {Countries.map((res, index) => {
                return (
                  <option value={res.dialCode} key={index}>
                    {res.flag}
                  </option>
                );
              })}
            </select>
          </span>
        </div>
        <button
          type="button"
          className="input_button"
          disabled={props.userNumber === "" ? true : false}
          onClick={() => handleClick()}
        >
          المتابعة{" "}
          <i className="fa fa-long-arrow-right ms-2" aria-hidden="true"></i>
        </button>
      </div>
    </>
  );
};
